/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { InlineNotification } from '@coursera/cds-core';

import _t from 'i18n!nls/account-settings';

type PaymentFormErrorsProps = {
  validationErrors: Array<string | null>;
};

const styles = {
  container: css`
    margin-bottom: var(--cds-spacing-200);
  `,
  list: css`
    margin: var(--cds-spacing-50) 0 var(--cds-spacing-100);
    padding-left: var(--cds-spacing-300);
  `,
};

const PaymentFormErrors = ({ validationErrors }: PaymentFormErrorsProps) => {
  const errors = validationErrors.filter(Boolean);

  if (errors.length === 0) {
    return null;
  }

  return (
    <div role="alert" aria-live="assertive" aria-atomic="true" css={styles.container}>
      <InlineNotification severity="error" title={_t('There was a problem.')}>
        <ul css={styles.list}>
          {errors.map((error) => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      </InlineNotification>
    </div>
  );
};

export default PaymentFormErrors;
